import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { under2camel } from 'lib/commonLib';

import NewInput from 'components/atoms/NewInput';
import NewCheckbox from 'components/molecules/NewCheckbox';

const useStyles = makeStyles((theme) => ({
  itemBox: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    width: 250,
    padding: '0 5px',
    margin: '1px 0',
  },
  inputStyle: { width: 70, '& > div > input': { textAlign: 'right' } },
}));

const TargetingSetting = (props) => {
  const { type, codeInfo, params, getParam, handleClickSnackbar } = props;
  const classes = useStyles();
  const lowKey = codeInfo['codeVal'].toLowerCase();
  const handleInput = (newParams, key) => {
    let tempParams = { ...newParams, [key]: Number(newParams[key]) };
    if (isNaN(Number(newParams[key]))) {
      handleClickSnackbar({
        message: '숫자만 입력해주세요.',
        option: { type: 'error' },
      });
    } else {
      getParam(lowKey + 'CpcWeight', tempParams);
    }
  };

  const handleCheckbox = (e) => {
    const { checked } = e.target;
    const key = under2camel(lowKey + '_' + type + '_send');
    getParam(key, { ...params, [key]: checked ? '01' : '02' });
  };

  return (
    <div className={classes.itemBox}>
      {type === 'cpc' ? (
        <NewCheckbox
          label={codeInfo['codeDesc']}
          name="useYn"
          onChange={handleCheckbox}
          checked={params[lowKey + 'CpcSend'] === '01'}
        />
      ) : (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          {codeInfo['codeDesc']}
        </div>
      )}
      <div className={classes.inputBox}>
        <NewInput
          type="tableInput"
          name={under2camel(lowKey + '_' + type + '_Weight')}
          params={params}
          value={params[under2camel(lowKey + '_' + type + '_Weight')]}
          callBack={handleInput}
          classes={{ root: classes.inputStyle }}
          inputProps={{ maxLength: 3 }}
        />
      </div>
    </div>
  );
};
export default TargetingSetting;
